import { supabase } from '../utils/supabaseClient'

interface PersonShort {
    id: bigint
    first_name: string
    last_name: string
    nick_name: string
    photo: string
    number: number
    club_name: string
    club_logo: string
    role: string
    type: string
    gender: string
    team_id: number
    club_id: number
}

const fetchPersonsByTeam = async (teamId: bigint): Promise<PersonShort[]> => {
    try {
        console.log('Fetching persons data for team...', teamId.toString())
        // Fetch Person Data for the given team
        const { data: personsData, error: personsError } = await supabase
            .from('persona_page_short')
            .select('*')
            .eq('team_id', teamId.toString())

        if (personsError) {
            console.error('Persons Error:', personsError)
            throw personsError
        }

        console.log('Persons Data (Short):', personsData)

        // Ensure that the data is correctly typed as an array of PersonShort
        return personsData as PersonShort[]
    } catch (error) {
        console.error('Error fetching persons:', error)
        throw error
    }
}

export default fetchPersonsByTeam